// Default avatar view
export const GENERIC_AVATAR = 'assets/ui/shared/icons/icon_avatar_generic.png';
